import { useAutocompleteSource, DictionaryAutocomplete } from '@eas/common-web';

export function useOperators() {
  return useAutocompleteSource<DictionaryAutocomplete>({
    url: '/api/ks/operators/autocomplete',
  });
}
